import type { TourDefinition } from '../types';

export const leadProfileTour: TourDefinition = {
  id: 'lead-profile',
  title: 'Perfil do Lead',
  steps: [
    {
      element: '[data-tour="lead-action-buttons"]',
      popover: {
        title: 'Ações Rápidas',
        description:
          'Converta em negócio, envie email, faça uma ligação ou edite o lead.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="lead-hero-card"]',
      popover: {
        title: 'Informações do Lead',
        description:
          'Veja e edite nome, status, responsável e dados de contato do lead.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="lead-contact-info"]',
      popover: {
        title: 'Contato',
        description:
          'Email, telefone e empresa vinculada. Use os ícones para ligar, copiar ou enviar WhatsApp.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="lead-custom-fields"]',
      popover: {
        title: 'Campos Personalizados',
        description:
          'Visualize e edite campos customizados criados para sua organização.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="lead-deals-section"]',
      popover: {
        title: 'Negócios Vinculados',
        description:
          'Veja todos os negócios associados a este lead e seus valores.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="lead-tabs"]',
      popover: {
        title: 'Histórico e Detalhes',
        description:
          'Alterne entre Timeline, Notas, Ligações, Emails e Arquivos para ver todo o histórico.',
        side: 'top',
        align: 'start',
      },
    },
  ],
};
